var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgShrink = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 20,
  height: 19,
  viewBox: "0 0 20 19",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M19.4995 1.12329L15.1748 5.44794H17.646V7.02054H12.4789L12.4789 1.85342L14.0515 1.85342V4.32465L18.3762 -9.53674e-07L19.4995 1.12329ZM1.62329 0.000629233L5.94794 4.32528V1.85405L7.52054 1.85405V7.02117L2.35342 7.02117L2.35342 5.44857L4.82465 5.44857L0.5 1.12392L1.62329 0.000629233ZM0.500012 17.8762L4.82466 13.5515H2.35343L2.35343 11.9789H7.52055L7.52055 17.146H5.94795L5.94795 14.6748L1.6233 18.9995L0.500012 17.8762ZM14.0515 14.6753L18.3762 19L19.4995 17.8767L15.1748 13.5521H17.646V11.9795L12.4789 11.9795V17.1466H14.0515V14.6753Z"
})));
export default SvgShrink;